<template>
  <div class="content">
    <div id="nav">
      <router-link to="/" tag="li">Home</router-link> |
      <router-link to="/about" tag="li">About me</router-link>
    </div>
    <div class="content-padding">
      <router-view/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Footer
  }
}
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
  min-height: 98vh;
}

.content-padding {
  padding-bottom: 2.5rem;
}

#nav {
  padding: 2rem;
}

</style>
